import { IBieApiResult, BieImportRow, IBieScenarioOption } from './bie.models';

export const postBiz = async <T = any>(payload: any): Promise<IBieApiResult<T>> => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok || data.failure) {
    throw new Error(data.em || data.message || 'BIE request failed');
  }

  return data;
};

export const fetchDashboardSummary = (scc: string) =>
  postBiz({ s: 'biedashboard', a: 'summary', scc });

export const fetchSimulator = (scc: string) =>
  postBiz({ s: 'biesimulator', a: 'get', scc });

export const updateSlider = (scc: string, drc: string, val: number) =>
  postBiz({ s: 'bieslider', a: 'update', scc, drc, val });

export const computeTarget = (
  scc: string,
  tdc: string,
  adc: string,
  trg: number,
  itr = 20,
  tol = 0
) => postBiz({ s: 'bietarget', a: 'compute', scc, tdc, adc, trg, itr, tol });

export const runSensitivity = (scc: string, tdc = 'RESPARTVAL', dlt = 10) =>
  postBiz({ s: 'bieanalysis', a: 'sensitivity', scc, tdc, dlt });

export const importExcelRows = (
  scc: string,
  rcd: BieImportRow[],
  fnm = 'bie_import.json',
  rmk = 'BIE import from workbench'
) =>
  postBiz({
    s: 'bieimport',
    a: 'excel',
    trk: null,
    scc,
    rcd,
    fnm,
    fdt: {},
    att: {},
    exi: {},
    rmk,
  });

const unwrapRows = (data: any) => {
  const rows = data?.sd || data?.result?.sd || data?.data?.sd || data;
  return Array.isArray(rows) ? rows : [];
};

export const fetchScenarioCombo = async (): Promise<IBieScenarioOption[]> => {
  const data = await postBiz({
    s: 'bie',
    a: 'bie',
    x:'bie',
    xop: 'scenarios',
  });

  return unwrapRows(data).map((row: any) => ({
    rid: row.rid,
    nam: row.nam,
  }));
};
